export const environment = {
  production: true,
  apiBaseUrl: 'https://api.institutionings.eu/api/' // placeholder
};
